
namespace RioERP.Masters {
    export class WhatsAppGatewaySettingsColumns {
        static columnsKey = 'Masters.WhatsAppGatewaySettings';
    }
}